import moment from 'moment';
// import store from './../store';

export default object => {
    let newObj = {};
    let copyObj = JSON.parse(JSON.stringify(object));
    Object.keys(copyObj).forEach(item => {
        if (moment.isMoment(copyObj[item])) {
            newObj[item] = copyObj[item].format('YYYY-DD-MM');
        } else if (item === 'startTime') {
            if (copyObj['sDate']) {
                // taking string values concatinating to build date and create moment object
                newObj['startDate'] = moment(
                    moment(copyObj['sDate']).format('YYYY-MM-DD') +
                        'T' +
                        moment(copyObj['startTime'], 'HH:mm').format('HH:mm:ss')
                ).utc();
                delete newObj['sDate'];
            }
        } else if (item === 'endTime') {
            if (copyObj['eDate']) {
                // taking string values concatinating to build date and create moment object
                newObj['endDate'] = moment(
                    moment(copyObj['eDate']).format('YYYY-MM-DD') +
                        'T' +
                        moment(copyObj['endTime'], 'HH:mm').format('HH:mm:ss')
                ).utc();
                delete newObj['eDate'];
            }
        } else if (item === 'category' && copyObj['category'] !== null) {
            newObj['category'] = copyObj['category'].map(item => item.value);
        } else if (item === 'behavior' || item === 'awareness') {
            newObj[item] = copyObj[item] === true ? '1' : '0';
        } else if (item === 'vendorsInformation') {
            newObj[item] = copyObj[item];
        } else if (item === 'PromotionalItem') {
            newObj[item] = copyObj[item];
        } else if (item === 'fundingRegionCode') {
            if (copyObj[item] === 'national') {
                newObj[item] = '';
            } else {
                newObj[item] = copyObj[item];
                newObj['regionCode'] = copyObj[item];
            }
        } else if (item === 'fundingDistrictCode') {
            newObj['fundingDistrictCode'] = copyObj[item];
            newObj['districtCode'] = copyObj[item];
        } else if (item === 'fundingRecruitingStationCode') {
            newObj['fundingRecruitingStationCode'] = copyObj[item];
            newObj['recruitingStationCode'] = copyObj[item];
        } else if (
            item === 'fundingRssOrOss' &&
            copyObj['ossRssType'] === 'OSS'
        ) {
            let value = copyObj[item].split('-');
            newObj['fundingOssCode'] = value[0];
            newObj['ossCode'] = value[0];
            newObj['fundingRecruitingSubStationCode'] = 'null';
            newObj['recruitingSubStationCode'] = 'null';
        } else if (
            item === 'fundingRssOrOss' &&
            copyObj['ossRssType'] === 'RSS'
        ) {
            let value = copyObj[item].split('-');
            newObj['fundingRecruitingSubStationCode'] = value[0];
            newObj['recruitingSubStationCode'] = value[0];
            newObj['fundingOssCode'] = 'null';
            newObj['ossCode'] = 'null';
        } else if (
            !copyObj[item] &&
            copyObj[item] !== undefined &&
            typeof copyObj[item] !== 'boolean'
        ) {
            delete newObj[item];
        } else {
            newObj[item] = copyObj[item];
        }
    });
    return newObj;
};



// WEBPACK FOOTER //
// ./src/helpers/validateObj.js